import { SET_FILTERS, SEARCH, SET_TABLE_SETTINGS } from '@gogame/screens';

import { tableSettingsSchema } from './schemas';

export const REORDER_COLUMNS = 'REORDER_COLUMNS';
export const COLLAPSE_COLUMNS = 'COLLAPSE_COLUMNS';

export { SET_TABLE_SETTINGS };

export default function integrationsReducer(state = {}, action) {
  switch (action.type) {
    case REORDER_COLUMNS:
      return { ...state, columns: { ...state.columns, order: action.payload } };
    case COLLAPSE_COLUMNS:
      return {
        ...state,
        columns: { ...state.columns, collapsed: action.payload },
      };

    case SET_FILTERS:
      return {
        ...state,
        // reset table settings on changing filters
        tableSettings: {
          ...tableSettingsSchema.default(),
          limit: state.tableSettings.limit,
        },
        filters: action.payload,
      };

    case SEARCH:
      return {
        ...state,
        // reset table settings on changing search
        tableSettings: {
          ...tableSettingsSchema.default(),
          limit: state.tableSettings.limit,
        },
        searchQuery: action.payload,
      };

    case SET_TABLE_SETTINGS:
      return {
        ...state,
        tableSettings: { ...state.tableSettings, ...action.payload },
      };

    default:
      return state;
  }
}
